import { NavLink } from "react-router-dom";
import { Car, Shield, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const MODES = [
  { id: "rider", to: "/ride", label: "Rider", icon: User },
  { id: "driver", to: "/drive", label: "Driver", icon: Car },
  { id: "admin", to: "/admin", label: "Admin", icon: Shield },
];

export function ModeSwitcher() {
  const { user } = useAuth();
  const available = MODES.filter((m) => user?.modes?.includes(m.id));
  if (available.length < 2) return null;
  return (
    <div className="flex gap-1 rounded-full border border-white/10 bg-black/60 p-1" data-testid="mode-switcher">
      {available.map((m) => (
        <NavLink key={m.id} to={m.to} data-testid={`mode-${m.id}`}
          className={({ isActive }) => `flex items-center gap-1 rounded-full px-2.5 py-1.5 text-xs font-semibold transition-colors ${
            isActive ? "bg-primary text-primary-foreground shadow-[0_0_12px_hsl(var(--primary)/0.5)]" : "text-muted-foreground hover:text-foreground"}`}>
          <m.icon className="h-3.5 w-3.5" /> <span className="hidden sm:inline">{m.label}</span>
        </NavLink>
      ))}
    </div>
  );
}
